import { RootState } from 'store/index';

export const selectJamfSync = (state: RootState) => {
  return state.integrations.jamf.sync;
};

export const selectJamfSyncStats = (state: RootState) => {
  return state.integrations.jamf.sync.stats;
};

export const selectJamfSyncedCount = (state: RootState) => {
  return state.integrations.jamf.sync.stats.synced;
};

export const selectJamfUnsyncedCount = (state: RootState) => {
  return state.integrations.jamf.sync.stats.unsynced;
};

export const selectJamfSyncCreatedAt = (state: RootState) => {
  return state.integrations.jamf.sync.createdAt;
};

export const selectJamfSyncProcessing = (state: RootState) => {
  return state.integrations.jamf.sync.processing;
};

export const selectJamfSyncInitialized = (state: RootState) => {
  return state.integrations.jamf.sync.initialized;
};

export const selectJamfSyncLoadingState = (state: RootState) => {
  return state.integrations.jamf.sync.loadingState;
};

export const selectJamfSyncGetLastSyncLoading = (state: RootState) => {
  return state.integrations.jamf.sync.getLastSyncLoading;
}; 
